module.exports = __webpack_public_path__ + "img/picture.7c4c4c71.svg";